module.exports = __webpack_public_path__ + "img/works_beijing_xikemu_1.adad3d4e.png";